import mReport from "@/models/mReport";

export default (value) => {
  const vocSourceToName = mReport.vocSourceToName();
  const res = vocSourceToName[value];
  return res;
}
